import React from 'react';

const WineIcon = (props) => {
  return (
    <img
      alt="Winnica"
      src="/static/images/icons/tourist_attractions/wine.svg"
      {...props}
    />
  );
};

export default WineIcon;
